import React from 'react'
import { Link, useParams } from 'react-router-dom'

import ShapeTwo from '../components/shape-two'
import Navbar from '../components/navbar_poc'
import Footer from '../components/footer'
import WhyIndiaCounter from '../components/whyindia-counter'
import VideoModalTwo from '../components/video-modal-two'
import SEO from '../components/seo'
import bg1 from '../assets/images/bg.jpg'
import aboutImg from '../assets/images/indiafutureisnow.jpg'

import {FiAirplay, FiMapPin, FiArrowRight, VscSend, FiUserCheck, FiMonitor, FiBriefcase,FiBook, FiDollarSign, FiClock} from '../assets/icons/vander'

import { jobData, jobDuties, jobSkill } from '../data/job'

export default function PageWhyIndia() {
  let params = useParams()
  let id = params.id;
  let data = jobData.find((job) => job.id === parseInt(id))

  return (
    <>
     <Navbar/> 
     <SEO
  title="Why India? – Strategic Reasons to Invest & Expand | Pioneer One Global"
  description="India is not just a market — it's a long-term growth opportunity. Discover why global businesses are turning to India for scale, talent, and innovation."
  url="https://www.pioneeroneglobal.com/why-india"
  image="https://www.pioneeroneglobal.com/images/og-why-india.jpg"
/>
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-lg-5 col-md-6">
                  <div className="position-relative">
                      <img src={aboutImg} className="img-fluid shadow rounded" alt=""/>
                      {/* <VideoModalTwo/> */}
                  </div>
              </div>

              <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <div className="section-title ms-md-4">
                      <h4 className="title mb-4">Why India?</h4>
                      <p className="text-muted">India stands today as one of the most dynamic and promising destinations for global business. With a rapidly expanding economy, a vibrant consumer market, and a deep reservoir of talent, she offers companies a unique combination of scale, speed, innovation, and opportunity.</p>
                      <p className="text-muted">Strategic policy reforms, infrastructure modernization, and a digital-first government approach have unlocked new pathways for international companies to invest, build, and thrive.</p>
                      <p className="text-muted">For organizations seeking growth, resilience, and long-term advantage, India is not just an option — it is a strategic imperative.</p>
                      <p className="text-muted">Explore why the world's leading companies are betting on India — and why now is the time to move.</p>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <ShapeTwo/>
    <WhyIndiaCounter/>
    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-lg-4 col-md-5 col-12">
                  <div className="card sidebar sticky-bar rounded shadow border-0">
                      <div className="card-body widget border-bottom">
                          <h5 className="mb-0">Fast Facts</h5>
                      </div>

                      <div className="card-body">
                          <div className="d-flex widget align-items-center">
                              <FiUserCheck className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">World’s Largest Democracy</h4>
                                  <p className="text-primary mb-0">Political stability, rule of law</p>
                              </div>
                          </div>

                          <div className="d-flex widget align-items-center mt-3">
                              <FiMapPin className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">Young Workforce</h4>
                                  <p className="text-primary mb-0">Median age just 28.4 years</p>
                              </div>
                          </div>

                          <div className="d-flex widget align-items-center mt-3">
                              <FiMonitor className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">Digital Leapfrogging</h4>
                                  <p className="text-primary mb-0">World's highest real-time digital payments volume</p>
                              </div>
                          </div>

                          <div className="d-flex widget align-items-center mt-3">
                              <FiBriefcase className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">Ease of Doing Business</h4>
                                  <p className="text-primary mb-0">Over 1,000 outdated laws repealed; major reforms underway</p>
                              </div>
                          </div>

                          <div className="d-flex widget align-items-center mt-3">
                              <FiBook className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">Sustainability Focus</h4>
                                  <p className="text-primary mb-0">Net zero by 2070 commitment, huge investments in renewables</p>
                              </div>
                          </div>

                      </div>
                  </div>
              </div>

              <div className="col-lg-8 col-md-7 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="ms-lg-4">
                      <h5>World's Fastest Growing Major Economy</h5>
                      <ul className="list-unstyled">
                      <li className="text-muted mt-2" key={1}><FiArrowRight className="fea icon-sm text-success me-2"/>India is projected to become the third-largest economy by 2030, fueled by strong GDP growth, domestic consumption, and global trade integration.</li>
                      <li className="text-muted mt-2" key={1}><FiArrowRight className="fea icon-sm text-success me-2"/>With 1.4 billion consumers, India offers both scale and diversity — from massive urban centers to rapidly expanding rural markets.</li>
                      <li className="text-muted mt-2" key={1}><FiArrowRight className="fea icon-sm text-success me-2"/>The government’s digital-first governance — initiatives like Aadhaar, UPI, and Digital India — have created a seamless environment for business, innovation, and financial inclusion.</li>
                      </ul>

                      <h5>Strategic Location: The China+1 Advantage</h5>
                      <ul className="list-unstyled">
                      <li className="text-muted mt-2" key={1}><FiArrowRight className="fea icon-sm text-success me-2"/>Global supply chains are evolving. Companies are diversifying beyond China to reduce risk — and India stands out as a natural, strategic choice.</li>
                      <li className="text-muted mt-2" key={1}><FiArrowRight className="fea icon-sm text-success me-2"/>India offers proximity to key markets in Asia, the Middle East, and Africa, along with strong global trade agreements.</li>
                      <li className="text-muted mt-2" key={1}><FiArrowRight className="fea icon-sm text-success me-2"/>Favorable time zones for both Western and Eastern markets make India a 24-hour business hub.</li>
 </ul>
                      <h5>Production-Linked Incentive (PLI) Schemes: Government Support for Growth</h5>
                      <ul className="list-unstyled">
                      <li className="text-muted mt-2" key={1}><FiArrowRight className="fea icon-sm text-success me-2"/>India has rolled out Production-Linked Incentive (PLI) schemes across multiple sectors, including electronics, pharmaceuticals, automotive, aerospace, textiles, and green energy.</li>
                      <li className="text-muted mt-2" key={1}><FiArrowRight className="fea icon-sm text-success me-2"/>Companies benefit from direct financial incentives, tax breaks, and infrastructure support — accelerating the return on investment.</li>
</ul>
                      <h5>Competitive Labor and Land Costs</h5>
                      <ul className="list-unstyled">
                      <li className="text-muted mt-2" key={1}><FiArrowRight className="fea icon-sm text-success me-2"/>India offers world-class talent at globally competitive salary levels — especially in sectors like technology, manufacturing, healthcare, and professional services.</li>
                      <li className="text-muted mt-2" key={2}><FiArrowRight className="fea icon-sm text-success me-2"/>Industrial corridors, Special Economic Zones (SEZs), and smart cities provide affordable land and world-class logistics support.</li>
                      <li className="text-muted mt-2" key={3}><FiArrowRight className="fea icon-sm text-success me-2"/>Businesses can scale flexibly while maintaining operational efficiency.</li>
                      </ul>

                      <h5 className="mt-4">Ready to Grow with India?</h5>
                      <p className="text-muted">At Pioneer One Global, we provide the clarity, connections, and confidence you need to set up, scale, and succeed in India.</p>
                      <p className="text-muted">We combine deep local expertise with global standards — so you can navigate India’s opportunities without the complexity.</p>

                      <div className="mt-4">
                          <Link to="/contact" className="btn btn-outline-primary">Schedule a Consultation<VscSend className=""/></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>

    </section>

    <Footer/>
    </>
  )
}
